import { render, staticRenderFns } from "./NewReservationsView.vue?vue&type=template&id=827bcfdc&"
import script from "./NewReservationsView.vue?vue&type=script&lang=js&"
export * from "./NewReservationsView.vue?vue&type=script&lang=js&"
import style0 from "./NewReservationsView.vue?vue&type=style&index=0&id=827bcfdc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports